import React from 'react';
import styled, { css } from 'styled-components';

import { colorStack } from '../../../styleHelpers/colors';
import { getStatusDotColor, getStatusFontColor, getStatusText, StatusMapper } from '../../../entities/IStatus';
import { useIntlMessage } from '../IntlMessage';

const Dot = styled.div<{ color: string; size: number }>`
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    margin-right: 0.5rem;
    background: ${props => props.color || colorStack.white};
    ${props =>
        props.size &&
        css`
            width: ${props.size}px;
            height: ${props.size}px;
        `};
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Name = styled.span<{ color: string }>`
    color: ${props => props.color || colorStack.content};
    width: calc(100% - 1.5rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface IStatusDotProps<T extends string | number> {
    status: T;
    mapper: StatusMapper<T>;
    size?: number;
    extended?: boolean;
}

export function StatusDot<T extends string | number>(props: React.PropsWithChildren<IStatusDotProps<T>>): React.ReactElement {
    const { intlFormatMessage } = useIntlMessage();

    return (
        <Wrapper>
            <Dot size={props.size} color={getStatusDotColor(props.mapper, props.status)} />
            {props.extended &&
                <Name color={getStatusFontColor(props.mapper, props.status)}>{intlFormatMessage({ id: getStatusText(props.mapper, props.status) })}</Name>
            }
        </Wrapper>
    );
}
